import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import myConnections from "../../utility/connect";
const sliceName = "countriesSlice";

const initialState = {
  countries: [],
  lockPhoneCountryCode: false,
  defCountryPhoneCode:  null
};

let getCountries = async (_, thunkAPI) => {
  const response = await myConnections.get({
    path: "sifrarnici/get_country_codes",
    data: {},
    headers: {},
    thunkAPI: thunkAPI,
  });


  return response;
};

getCountries = createAsyncThunk(`${sliceName}/getCountries`, getCountries);
getCountries.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {
    state.countries = action.payload.items[0].countries;
    state.lockPhoneCountryCode = action.payload.items[0].lock_country_code === 'Y';
    state.defCountryPhoneCode = state.countries.find(element => element.isdefault === "Y")?.phone_code;
  },
  rejected: (state, action) => {
  },
};

const countriesSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getCountries.pending, getCountries.myLC.pending);
    builder.addCase(getCountries.fulfilled, getCountries.myLC.fulfilled);
    builder.addCase(getCountries.rejected, getCountries.myLC.rejected);
  },
});

export const asyncActions = { getCountries };
export const actions = countriesSlice.actions;
export default countriesSlice.reducer;
